export default function ProcessHero() {
  return (
    <>
      <section id="process_hero" className="hero-section-all">
        <div className="container">
          <div className="process-hero-wrapper">
            <h1>The Process</h1>
            <p>The ABC of magic</p>
          </div>
        </div>
      </section>
    </>
  );
}
